import React, { useState, useEffect } from "react";
import assetLoader from "./AssetLoader";

const AssetPanel = ({ onAddAsset }) => {
  const [categories, setCategories] = useState({});
  const [expandedCategories, setExpandedCategories] = useState({
    speechBubbles: true
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load assets on component mount
  useEffect(() => {
    loadAssets();
  }, []);

  const loadAssets = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const assetStructure = await assetLoader.loadAssets();
      setCategories(assetStructure);
      
      // Set initial expanded state for all categories
      const initialExpanded = {};
      Object.keys(assetStructure).forEach(key => {
        initialExpanded[key] = true;
      });
      setExpandedCategories(initialExpanded);
      
    } catch (err) {
      console.error('Failed to load assets:', err);
      setError('Failed to load assets. Please refresh the page.');
    } finally {
      setLoading(false);
    }
  };

  const refreshAssets = async () => {
    await loadAssets();
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const handleDragStart = (e, asset) => {
    if (asset.type === "speechBubble") return; // Text bubbles don't drag
    e.dataTransfer.setData("application/json", JSON.stringify(asset));
    e.dataTransfer.effectAllowed = "copy";
  };

  const handleAddTextBubble = () => {
    onAddAsset({
      id: "speechBubble",
      type: "speechBubble",
      name: "Speech Bubble"
    });
  };

  const renderAsset = (asset) => {
    if (asset.type === "speechBubble") {
      return (
        <div
          key={asset.id}
          className="asset-item text-bubble-item"
          onClick={handleAddTextBubble}
        >
          <div className="text-bubble-preview">
            <div className="bubble-icon">{asset.icon}</div>
          </div>
          <span className="asset-name">{asset.name}</span>
        </div>
      );
    }

    return (
      <div
        key={asset.id}
        className="asset-item"
        draggable
        onDragStart={(e) => handleDragStart(e, asset)}
        onClick={() => onAddAsset(asset)}
      >
        <img
          src={asset.src}
          alt={asset.name}
          className="asset-preview"
        />
        <span className="asset-name">{asset.name}</span>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="asset-panel">
        <h3>Assets</h3>
        <div className="loading-message">Loading assets...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="asset-panel">
        <h3>Assets</h3>
        <div className="error-message">
          <p>{error}</p>
          <button onClick={refreshAssets} className="refresh-button">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="asset-panel">
      <div className="asset-panel-header">
        <h3>Assets</h3>
        <button 
          onClick={refreshAssets} 
          className="refresh-button"
          title="Refresh assets"
        >
          🔄
        </button>
      </div>
      
      {Object.entries(categories).map(([categoryKey, category]) => (
        <div key={categoryKey} className="asset-category">
          <div 
            className="category-header"
            onClick={() => toggleCategory(categoryKey)}
          >
            <span className="category-title">{category.title}</span>
            <span className="category-toggle">
              {expandedCategories[categoryKey] ? '▼' : '▶'}
            </span>
          </div>
          
          {expandedCategories[categoryKey] && (
            <div className="assets-grid">
              {category.assets.map(renderAsset)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AssetPanel;
